
import { LatLngTuple } from "leaflet";
import { ActionFunctionArgs, LoaderFunctionArgs, redirect } from "react-router-dom";
import { myAxios } from "src/components/common/functions";
import { fields } from "./UserFilterForm";
import { appendField } from "../common/FilterFrame/FilterField";
import { saveAs } from "file-saver";
import { extraFields } from "./UserList";
import { buildDefaultState } from "../common/FilterFrame/FilterModal";

export async function userLoader({ params, request }: LoaderFunctionArgs) {
    const controller = new AbortController();
    request.signal.addEventListener("abort", () => {
        controller.abort();
    });
    const { id } = params;
    const formData = new FormData();
    if(!id) return;
    formData.append("curUserId", id);
    const res = await myAxios({ fileName: "users/readUser.php", formData: formData, signal: controller.signal });
    if (!res) return;
    if (!res.data) {
        throw redirect("..");
    }
    const user = {...res.data, coords: res.data.coords ? res.data.coords.split(",").map((v: string) => Number(v)) as LatLngTuple : [37.6148754, -122.0874473] as LatLngTuple};
    return user;
}
export async function usersLoader({ request }: LoaderFunctionArgs) {
    const controller = new AbortController();
    request.signal.addEventListener("abort", () => {
        controller.abort();
    });
    const url = new URL(request.url);
    let shouldRedirect = false;
    for (const [key] of url.searchParams) {
        if(![...Object.keys(buildDefaultState(fields)), ...extraFields].includes(key)){
            url.searchParams.delete(key);
            shouldRedirect = true;
        }
    }
    if (!url.searchParams.get("page")) {
        url.searchParams.set("page", "1");
        shouldRedirect = true;
    }
    if (!url.searchParams.get("limit")) {
        url.searchParams.set("limit", "10");
        shouldRedirect = true;
    }
    if (shouldRedirect) throw redirect(url.pathname + "?" + url.searchParams.toString());
    const formData = new FormData();
    formData.append("page", url.searchParams.get("page")!);
    formData.append("limit", url.searchParams.get("limit")!);
    for(const field of fields){
        appendField(formData, url.searchParams, field);
    }
    const res = await myAxios({
        fileName: "users/readUsers.php", 
        formData, 
        signal: controller.signal
    });
    if(!res) throw redirect("..");
    return res.data;
}

const apiMap = {
    "Add": "users/createUser.php",
    "Edit": "users/updateUser.php",
};
export async function userAction({ request }: ActionFunctionArgs){
    const controller = new AbortController();
    request.signal.addEventListener("abort", () => {
        controller.abort();
    });
    const formData = await request.formData();
    const url = apiMap[formData.get("keyword") as ("Add" | "Edit")];
    if(formData.get("quitDate") === "") formData.delete("quitDate");
    if(formData.get("birthDay") === "") formData.delete("birthDay");
    if(formData.get("curOffice") === "yes" && formData.get("office") === "no"){
        if(!window.confirm("Are you sure to remove the access of office time card?\nThis action will remove all the time card data of this user.")){
            return;
        }
    }
    if(formData.get("curOutside") !== "no" && formData.get("curOutside") && formData.get("outside") === "no"){
        if(!window.confirm("Are you sure to remove the access of outside time card?\nThis action will remove all the time card data of this user.")){
            return;
        }
    }
    const res = await myAxios({
        fileName: url, 
        formData, 
        signal: controller.signal
    });
    if (!res) return;
    const newUserId = res.data.id;
    if (newUserId) {
        return redirect(`../${newUserId}`);
    }
    return redirect("..");
}
export async function userExportAction({ request }: ActionFunctionArgs){
    const controller = new AbortController();
    request.signal.addEventListener("abort", () => {
        controller.abort();
    });
    const url = new URL(request.url);
    const formData = await request.formData();
    for(const field of fields){
        appendField(formData, url.searchParams, field);
    }
    const res = await myAxios({
        fileName: `/users/exportUsers.php`,
        formData, 
        responseType: "blob", 
        signal: controller.signal
    });
    if(!res) throw redirect(`..?${url.searchParams.toString()}`);
    const disposition = res.headers["content-disposition"];
    let filename = "users.xlsx";
    if (disposition) {
        const match = disposition.match(/filename="?(.+?)"?$/);
        if (match) filename = decodeURIComponent(match[1]);
    }
    saveAs(
        new Blob([res.data], {
            type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
        }),
        filename
    );
    throw redirect(`..?${url.searchParams.toString()}`);
}

export async function deleteUserAction({ request }: ActionFunctionArgs) {
    const controller = new AbortController();
    request.signal.addEventListener("abort", () => {
        controller.abort();
    });
    const formData = await request.formData();
    if(!formData.get("id")){
        throw new Response("Missing id", { status: 400 });
    }
    const res = await myAxios({
        fileName: "users/deleteUser.php",
        formData: formData, 
        signal: controller.signal
    });
    if(!res) throw redirect("..");
    throw redirect("../..");
}

export async function voidUserAction({ request }: ActionFunctionArgs) {
    const controller = new AbortController();
    request.signal.addEventListener("abort", () => {
        controller.abort();
    });
    const formData = await request.formData();
    if(!formData.get("id")){
        throw new Response("Missing id", { status: 400 });
    }
    await myAxios({
        fileName: "users/voidUser.php",
        formData: formData, 
        signal: controller.signal
    });
    throw redirect("..");
}

export async function validateUserAction({ request }: ActionFunctionArgs) {
    const controller = new AbortController();
    request.signal.addEventListener("abort", () => {
        controller.abort();
    });
    const formData = await request.formData();
    if(!formData.get("id")){
        throw new Response("Missing id", { status: 400 });
    }
    await myAxios({
        fileName: "users/validateUser.php",
        formData: formData, 
        signal: controller.signal
    });
    throw redirect("..");
}